import { z } from 'zod';

export const ListTagsInput = z.object({
  name: z.string().optional(),
});
